import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import {
  CONFIRM_LABEL,
  DATA,
  DIALOG_SHOW,
  DIALOG_TEXT,
  DIALOG_TITLE,
  DISMISS_LABEL,
  hideDialog,
  ICON,
  ON_CONFIRM_DIALOG,
  showDialog,
  SPECIAL_CANCEL_FUNCTION
} from "../../ducks/confirmDialog";
import { LINKS_SURVEY_ADMIN_ENTRY, LINKS_SURVEY_ENTRY } from "../../ducks/login";
import { hideRunner, SENDING_DATA_IS_IN_PROGRESS } from "../../ducks/surveyRunner";
import ConfirmDialog from "./ConfirmDialog";

const mapStateToProps = (state) => {
  return {
    show: state.confirmDialog[DIALOG_SHOW],
    data: state.confirmDialog[DATA],
    onConfirmDialog: state.confirmDialog[ON_CONFIRM_DIALOG],
    dialogTitle: state.confirmDialog[DIALOG_TITLE],
    dialogText: state.confirmDialog[DIALOG_TEXT],
    confirmLabel: state.confirmDialog[CONFIRM_LABEL],
    dismissLabel: state.confirmDialog[DISMISS_LABEL],
    specialCancelFunction: state.confirmDialog[SPECIAL_CANCEL_FUNCTION],
    icon: state.confirmDialog[ICON],
    link: state.login[LINKS_SURVEY_ENTRY],
    surveyAdminLink: state.login[LINKS_SURVEY_ADMIN_ENTRY],
    sendingDataIsInProgress: state.surveyRunner[SENDING_DATA_IS_IN_PROGRESS]
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({ 
    showDialog, 
    hideDialog, 
    hideRunner,
  }, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(ConfirmDialog);
